module.exports = __webpack_public_path__ + "img/pspmiv26whnfddc8o3zg1jm8vmllbvj11c2550d315-a5f9-4810-8571-0c179e4d0d47.6f910ca9.png";